import axios from "axios";
import store from "../store/store";

/* ====================================================================================
  Item Name: nestedObjectToArray
  Author URL: https://codereview.stackexchange.com/questions/126777/get-all-combination-of-a-nested-object/126778#126778
========================================================================================*/
const nestedObjectToArray = (obj) => {
        if (typeof(obj) !== "object"){
        return [obj];
    }
    var result = [];
    if (obj.constructor === Array){
        obj.map(function(item) {
            result = result.concat(nestedObjectToArray(item));
        });
    } else {
        Object.keys(obj).map(function(key) {
            if(obj[key]) {
                var chunk = nestedObjectToArray(obj[key]);
                chunk.map(function(item) {
                    if(key === "username") {
                        key = 'email'
                        item = 'A user with that email already exists.'
                    }
                    result.push(key+"-"+item);
                });
            } else {
                result.push(key);
            }
        });
    }
    return result;
};
const checkLoginState=() =>{
  if (store.getters.getToken==null)
    {
      window.location="/login"
    }
}
const sendRequest = (requestType, endpoint, data = null, successCallback = null, errorCallback = null,
    self = null) => {
    self.$vs.loading();
    var url = null;
    if (endpoint.includes("https") || endpoint.includes("http")) {
      url = endpoint;
    } else {
      url = process.env.VUE_APP_API + endpoint;
    }
    var headers = {
      headers: {
        Authorization: "JWT " + store.getters.getToken
      }
    };
    var requestObject = {
      get: axios.get,
      post: axios.post,
      delete: axios.delete,
      put: axios.put,
      patch: axios.patch
    };
    var request = null;
    if (data) {
      request = requestObject[requestType](url, data, headers);
    } else {
      request = requestObject[requestType](url, headers);
    }
    request
      .then(response => {
        if (successCallback) {
          self.$vs.loading.close();
          successCallback(response);
        }
      })
      .catch(error => {
        self.$vs.loading.close();
        if (error.response.status === 404) {
          window.location = "*"
        }
        if (error.response.status === 401) {
          store.commit("LOGOUT")
          window.location = "/login"
        }
        if (self) {
          var errorsArray = nestedObjectToArray(error.response.data);
          errorsArray.forEach(errorMessage => {
            self.$vs.notify({
                title: 'Error',
                position: 'top-right',
                text: errorMessage,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'})
          });
        }
        if (errorCallback) {
          errorCallback(error);
        }
      })
      .then(() => {
      });
  };
  
export { nestedObjectToArray, sendRequest, checkLoginState };
